import React from 'react';
import classnames from 'classnames';
import styles from './StatusItem.module.scss';

export type StatusItemProps = {
  value: number,
  message: React.ReactNode,
}

const StatusItem = ({value, message}: StatusItemProps) => {

  return (
    <div
      className={classnames(
        styles.statusContainer,
        value === 1 && styles.statusOpened,
        value === 2 && styles.statusClosed,
        value === 3 && styles.statusConvertedToInvoice,
        value === 4 && styles.statusConvertedToInvoiceReceipt,
      )}
    >
      {message}
    </div>
  );
};

export default StatusItem;
